module.exports = __webpack_public_path__ + "static/media/micky.c7638173.png";